import {useSearchParams} from "react-router-dom";
import {useGetTechnologicalOperationQuery} from "../../store/backend-api/backend.api";
import React, {useEffect, useState} from "react";
import {
    TechnologicalOperationFormRead
} from "../../components/technological-operation/form/TechnologicalOperationFormRead";

export function ReadTechnologicalOperationForm() {
    const [searchParams] = useSearchParams()
    const id = Number(searchParams.get("id"))
    const {data, isSuccess} = useGetTechnologicalOperationQuery(id)
    const [key, setKey] = useState(0)

    useEffect(() => {
        setKey((prevState) => prevState + 1)
    }, [data])

    return (<div key={key}>
        {isSuccess && (<TechnologicalOperationFormRead data={data}/>)}
    </div>)
}